import React, { useState, useEffect } from 'react';
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import './AskSearchFeature.scss';
import useTheme from "../../components/useTheme/useTheme";
import { registrationFormURL } from "../../components/helpers/constant-words";
// import http from "../../helpers/http";
// import config from "../../config/config";

const AskSearchFeature = () => {
  const { theme } = useTheme();

  return (
    <div className={`ask-search-feature ${theme === "dark" ? "dark" : ""}`}>
      {/* Header Section - Commented Out
      <div className="ask-search-header">
        <div className="header-content">
          <div className="title-badge-column">
            <h2 className="ask-search-title">
              Archinza AI<sup>TM</sup> <span className="ask-search-title-black">Ask & Search</span>
            </h2>
            <span className="badge">
              COMING SOON
            </span>
          </div>
          <p className="description">
            Experience the power of AI-driven visual search and discovery
          </p>
        </div>
        <div className="timer-wrapper">
          <CountdownTimer />
        </div>
      </div>
      */}

      {/* Pinterest-style Feature Section - Orange Theme */}
      <PinterestStyleFeatureOrange />

      {/* Original Pinterest-style Feature Section - Commented Out */}
      {/* <PinterestStyleFeature /> */}

      {/* Original Carousel - Commented Out */}
      {/* <FeaturesCarousel /> */}
    </div>
  );
};

/* COMMENTED OUT - Original Pinterest-style Feature (light theme with dots)
const PinterestStyleFeature = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const features = [
    { text: "materials, enquire businesses, and make informed decisions.", color: "#E60023", image: "/images/Features_ask_search/2.png", scale: 1.3 },
    { text: "similar products that match your style and needs.", color: "#0076D3", image: "/images/Features_ask_search/3.jpeg" },
    { text: "materials using image recognition and get recommendations.", color: "#2AA786", image: "/images/Features_ask_search/1.png", scale: 1.3 },
    { text: "every product that makes up a room.", color: "#9270D7", image: "/images/Features_ask_search/5.jpeg" },
    { text: "standout products and save them for later.", color: "#FA5F2E", image: "/images/Features_ask_search/4.jpeg" },
    { text: "products from image-based recognition.", color: "#C856C8", image: "/images/Features_ask_search/6.jpeg" }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % features.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [features.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="pinterest-feature">
      <div className="pinterest-feature__container">
        <div className="pinterest-feature__text-section">
          <h2 className="pinterest-feature__heading">Find</h2>
          <div className="pinterest-feature__rotating-text-container">
            {features.map((feature, index) => (
              <span
                key={index}
                className={`pinterest-feature__rotating-text ${index === currentIndex ? 'active' : ''}`}
                style={{
                  color: feature.color,
                  transform: `translateY(${(index - currentIndex) * 140}px)`,
                  opacity: index === currentIndex ? 1 : 0
                }}
              >
                {feature.text}
              </span>
            ))}
          </div>
          <div className="pinterest-feature__dots">
            {features.map((feature, index) => (
              <button
                key={index}
                className={`pinterest-feature__dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to ${feature.text}`}
                style={{
                  background: index === currentIndex
                    ? `linear-gradient(${feature.color}, ${feature.color}dd)`
                    : '#e0e0d9'
                }}
              />
            ))}
          </div>
        </div>
        <div className="pinterest-feature__image-section">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`pinterest-feature__image-frame ${index === currentIndex ? 'active' : ''}`}
            >
              <img
                src={feature.image}
                alt={feature.text}
                style={feature.scale ? { transform: `scale(${feature.scale})` } : {}}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
*/

// Pinterest-style Feature - Orange Theme with Email Notify
const PinterestStyleFeatureOrange = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  /* Email Notify - Commented Out
  const [email, setEmail] = useState("");
  const [notifyStatus, setNotifyStatus] = useState("");
  const base_url = config.api_url;

  const handleNotify = async () => {
    if (!email || !email.includes("@")) {
      setNotifyStatus("error");
      return;
    }
    setNotifyStatus("loading");
    const response = await http.post(`${base_url}/personal/ask-search-notify`, { email });
    if (response) {
      setNotifyStatus("success");
      setEmail("");
    } else {
      setNotifyStatus("error");
    }
  };
  */

  const features = [
    { text: "the right solutions for your design needs with Intelligent Ask & Search.", color: "#2563eb", image: "/Personal/Personal_listing.png", objectFit: "contain", scale: 1.8 },
    { text: "materials, enquire businesses, and make informed decisions.", color: "#2563eb", image: "/images/Features_ask_search/2.png", scale: 1.3 },
    { text: "similar products that match your style and needs.", color: "#2563eb", image: "/images/Features_ask_search/3.jpeg" },
    { text: "materials using image recognition and get recommendations.", color: "#2563eb", image: "/images/Features_ask_search/1.png", scale: 1.3 },
    { text: "every product that makes up a room.", color: "#2563eb", image: "/images/Features_ask_search/5.jpeg" },
    { text: "standout products and save them for later.", color: "#2563eb", image: "/images/Features_ask_search/4.jpeg" },
    { text: "products from image-based recognition.", color: "#2563eb", image: "/images/Features_ask_search/6.jpeg" }
  ];

  // Auto-rotate every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % features.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [features.length]);

  return (
    <div className="pinterest-feature pinterest-feature--orange">
      <div className="pinterest-feature__container">
        {/* Left Side - Text */}
        <div className="pinterest-feature__text-section">
          <h2 className="pinterest-feature__heading">Find</h2>

          <div className="pinterest-feature__rotating-text-container">
            {features.map((feature, index) => (
              <span
                key={index}
                className={`pinterest-feature__rotating-text ${
                  index === currentIndex ? 'active' : ''
                }`}
                style={{
                  color: feature.color,
                  transform: `translateY(${(index - currentIndex) * 140}px)`,
                  opacity: index === currentIndex ? 1 : 0
                }}
              >
                {feature.text}
              </span>
            ))}
          </div>

          {/* Dot Indicators */}
          <div className="pinterest-feature__dots">
            {features.map((_, index) => (
              <button
                key={index}
                className={`pinterest-feature__dot ${
                  index === currentIndex ? 'active' : ''
                }`}
                onClick={() => setCurrentIndex(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>

          {/* Email Notify Section - Commented Out
          <div className="pinterest-feature__notify">
            {notifyStatus === "success" ? (
              <p className="pinterest-feature__notify-text">Thanks! We'll notify you when we launch.</p>
            ) : (
              <>
                <p className="pinterest-feature__notify-text">Be among the first to try Archinza AI</p>
                <div className="pinterest-feature__notify-input">
                  <input
                    type="email"
                    placeholder="Your Email"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); setNotifyStatus(""); }}
                    className="pinterest-feature__email-input"
                  />
                  <button
                    className="pinterest-feature__notify-btn"
                    onClick={handleNotify}
                    disabled={notifyStatus === "loading"}
                  >
                    {notifyStatus === "loading" ? "Sending..." : "Notify me"}
                  </button>
                </div>
              </>
            )}
          </div>
          */}

          {/* Get Started CTA */}
          <div className="pinterest-feature__notify">
            <div className="pinterest-feature__cta-wrapper">
              <Link
                to={registrationFormURL}
                className="pinterest-feature__cta-btn"
              >
                Get Started
                <ArrowRight className="pinterest-feature__cta-icon" />
              </Link>
              <span className="pinterest-feature__button-subtext">Free for a limited time only</span>
            </div>
          </div>
        </div>

        {/* Right Side - Full Frame Image */}
        <div className="pinterest-feature__image-wrapper">
          <span className="pinterest-feature__badge">COMING SOON</span>
          <div className="pinterest-feature__image-section">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`pinterest-feature__image-frame ${
                index === currentIndex ? 'active' : ''
              }`}
            >
              <img
                src={feature.image}
                alt={feature.text}
                style={{
                  ...(feature.scale ? { transform: `scale(${feature.scale})` } : {}),
                  ...(feature.objectFit ? { objectFit: feature.objectFit } : {})
                }}
              />
            </div>
          ))}
          </div>
        </div>
      </div>
    </div>
  );
};

/* ============================================
   ORIGINAL CAROUSEL - COMMENTED OUT
   ============================================ */

/*
// Features Carousel Component
const FeaturesCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isDesktop, setIsDesktop] = useState(false);

  const features = [
        {
      image: "/images/Features_ask_search/2.jpeg",
      title: "From inspiration to inquiry",
      description: "View specifications, explore variants, and connect directly with manufacturers."
    },
    {
      image: "/images/Features_ask_search/1.jpeg",
      title: "Identify products and materials",
      description: "Identify furniture and decor items in any room instantly with AI-powered image recognition"
    },
    {
      image: "/images/Features_ask_search/3.jpeg",
      title: "See every element that makes up a room",
      description: "Archinza tags beds, lighting, furniture, and finishes so you can source the exact look."
    },
    {
      image: "/images/Features_ask_search/4.jpeg",
      title: "Smart Search & Match",
      description: "Search by image and find exact or similar products from our curated database"
    },
    {
      image: "/images/Features_ask_search/5.jpeg",
      title: "Choose finishes with confidence",
      description: "Explore tiles, textures, and surfaces that fit perfectly into your design context."
    },
    {
      image: "/images/Features_ask_search/6.jpeg",
      title: "AI-Powered Assistance",
      description: "Get expert recommendations and connect with suppliers through our intelligent chat system"
    }
  ];

  // Check if desktop on mount and window resize
  useEffect(() => {
    const checkDesktop = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };

    checkDesktop();
    window.addEventListener('resize', checkDesktop);

    return () => window.removeEventListener('resize', checkDesktop);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % features.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + features.length) % features.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  // Auto-scroll every 5 seconds (only on desktop)
  useEffect(() => {
    if (!isDesktop) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % features.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [features.length, isDesktop]);

  return (
    <div className="features-carousel">
      <div className="carousel-container">
        <div
          className="carousel-track"
          style={isDesktop ? { transform: `translateX(-${currentSlide * 100}%)` } : {}}
        >
          {features.map((feature, index) => (
            <div key={index} className="carousel-slide">
              <div className="slide-content">
                <div className="image-section">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="feature-image"
                  />
                </div>

                <div className="text-section">
                  <h3 className="feature-title">
                    {feature.title}
                  </h3>
                  <p className="feature-description">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <button
        onClick={prevSlide}
        className="nav-arrow nav-arrow-left"
        aria-label="Previous slide"
      >
        <ChevronLeft className="arrow-icon" />
      </button>
      <button
        onClick={nextSlide}
        className="nav-arrow nav-arrow-right"
        aria-label="Next slide"
      >
        <ChevronRight className="arrow-icon" />
      </button>

      <div className="dots-container">
        {features.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`dot ${currentSlide === index ? 'dot-active' : ''}`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};
*/

// Countdown Timer Component
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    // Set target date (you can modify this to your desired launch date)
    const targetDate = new Date('2026-04-01T00:00:00').getTime();

    const updateTimer = () => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000)
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, []);

  const TimeUnit = ({ value, label }) => (
    <div className="time-unit">
      <div className="time-value">
        {String(value).padStart(2, '0')}
      </div>
      <div className="time-label">
        {label}
      </div>
    </div>
  );

  return (
    <div className="countdown-timer">
      <TimeUnit value={timeLeft.days} label="Days" />
      <span className="time-separator">:</span>
      <TimeUnit value={timeLeft.hours} label="Hours" />
      <span className="time-separator">:</span>
      <TimeUnit value={timeLeft.minutes} label="Minutes" />
      <span className="time-separator">:</span>
      <TimeUnit value={timeLeft.seconds} label="Seconds" />
    </div>
  );
};

export default AskSearchFeature;
